import React from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'

import Alert from 'Components/Alert'
import Modal from 'Components/Modal'
import LoadingSpinner from 'Components/LoadingSpinner'

const UserWithSharedFilter = ({
  customFilterUsers,
  customFilter
}) => {
  if (_.some(customFilterUsers)) {
    const filterCreator = _.find(customFilterUsers, user => user.id === customFilter.user_id) || {}
    return (
      <p>
        Shared by
        {' '}
        {filterCreator.name}
      </p>
    )
  }

  return (
    <p>
      Loading...
    </p>
  )
}

const DestroyButton = ({ customFilter }) => (
  <button
    type="button"
    className="link link--destructive"
    onClick={() => {
      if (window.confirm('Are you sure you want to delete this ticket filter?')) {
        customFilter.remove()
      }
    }}
  >
    DELETE
  </button>
)

const EditButton = ({ onClick }) => (
  <button
    type="button"
    className="link"
    onClick={onClick}
  >
    EDIT
  </button>
)

const ApplyButton = ({ onClick }) => (
  <button
    type="button"
    className="link"
    onClick={onClick}
  >
    APPLY
  </button>
)

const CustomFiltersModal = ({
  showModal,
  removeModal,
  customFilters,
  customFilterUsers,
  loadingCustomFilters
}) => {
  if (loadingCustomFilters) {
    return (
      <Modal showModal={showModal} title="My Custom Filters" removeModal={() => removeModal()}>
        <LoadingSpinner />
      </Modal>
    )
  }

  if (_.isEmpty(customFilters)) {
    return (
      <Modal showModal={showModal} title="My Custom Filters" removeModal={() => removeModal()}>
        <Alert alertType="error">
          You don&apos;t own any custom filters
        </Alert>
      </Modal>
    )
  }

  return (
    <div>
      <Modal showModal={showModal} title="My Custom Filters" removeModal={() => removeModal()}>
        <ul className="list list--no-list-style">
          {_.map(customFilters, (customFilter) => {
            const {
              filters,
              id,
              name,
              edit,
              apply
            } = customFilter
            const filtersWithValue = _.filter(filters, filter => filter.text || filter.value)
            return (
              <li key={id} className="list__item--bottom-bordered">
                <div className="flex flex--space-between">
                  <p style={{ margin: '0' }}>
                    <strong>
                      {name}
                    </strong>
                  </p>

                  <div>
                    {
                      (customFilter.filter_creator && (
                        <>
                          <DestroyButton customFilter={customFilter} />
                        |
                          <EditButton onClick={() => { edit() }} />
                        |
                        </> )
                      ) || (customFilter.admin_policy_owner && (
                        <>
                        <DestroyButton customFilter={customFilter} />
                        |
                        </> )
                      )
                    }
                    <ApplyButton onClick={() => apply()} />
                  </div>
                </div>

                <p>
                  {_.join(_.map(filtersWithValue, filter => (
                    `${filter.title || 'ID or Title'} is ${filter.type ? '' : 'like '}${filter.label || filter.value}`
                  )), ' AND ')}
                </p>
                {customFilter.shared && (
                  <div className="decorated">
                    <UserWithSharedFilter
                      customFilter={customFilter}
                      customFilterUsers={customFilterUsers}
                    />
                  </div>
                )}
              </li>
            )
          })}
        </ul>
      </Modal>
    </div>
  )
}

CustomFiltersModal.propTypes = {
  showModal: PropTypes.bool.isRequired,
  removeModal: PropTypes.func.isRequired,
  customFilterUsers: PropTypes.arrayOf(PropTypes.object).isRequired,
  customFilters: PropTypes.arrayOf(PropTypes.object).isRequired
}

UserWithSharedFilter.propTypes = {
  customFilterUsers: PropTypes.arrayOf(PropTypes.object).isRequired
}

export default CustomFiltersModal
